module.exports = __webpack_public_path__ + "static/media/bannerblackphone.39a799af.png";